import type { SVGProps } from 'react';

const LoadingTaskIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <circle cx="16" cy="16" r="8" stroke="#262626" strokeWidth="3" />
    <path
      d="M16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8"
      stroke="#78DC00"
      strokeWidth="3"
    />
    <path
      d="M16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8"
      stroke="#78DC00"
      strokeWidth="3"
    />
  </svg>
);
export default LoadingTaskIcon;
